class CookiesServiceClass {
    get(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for(var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    set(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires="+d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";domain=.seagage.com;path=/";
    }

    delete() {
        const HOST = location.hostname === 'localhost' ? location.hostname : '.seagage.com';
        document.cookie = `auth_token=; Max-Age=0; path=/; domain=${HOST}`;
    }
}

let CookiesService = new CookiesServiceClass();
export default CookiesService;
